import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    amount: number;
}

function CardAmount({ amount }:Props) {
    const { t } = useTranslation('gift');
    return (
        <Column spacing={22} fullWidth>
            <Text size='2xl' fontWeight='bold' color={colors.gray7}>
                {t('giftOrder.purchaseAmount')}
            </Text>
            <Amount>
                <Chip isSelected>{amount / 10000}{t('giftOrder.amountUnit')}</Chip>
            </Amount>
        </Column>
    );
}

const Amount = styled(Chip.Container)`
    padding: 2px;
    margin-left: -2px;
    margin-bottom: -2px;
`;

export default CardAmount;
